import * as apiTo from '@/modular-api'
import store from '@/store'

export function isSubShow() {
  return store.hasModule('subscription-show')
}

export function getCount() {
  return this.quickViewItems.length
}

export function setSubtitle(title) {
  return function(value) {
    if (Array.isArray(value)) {
      this.$emit('set-subtitle', `${title} (${value.length})`)
    }
  }
}

export function checkQuickView() {
  if (this.quickViewItems.length === 1) this.$emit('make-count-0')
  else {
    const index = this.quickViewItems.findIndex(g => g.id === this.quickView.id)
    if (~index) {
      this.quickViewItems.splice(index, 1)

      const activeIndex = this.$refs.modalSidebar.getSelectedIndex()

      if (activeIndex === 0) this.$refs.modalSidebar.onItemSelected(0)
      else this.$refs.modalSidebar.setSelectedIndex(activeIndex - 1)
    }
  }
}

export function openQuickView(taskName, thenFn) {
  return function(quickViewItem) {
    this.$emit('set-loader', true)

    apiTo
      .GET_TASK_QUICK_VIEW(taskName, quickViewItem.id)
      .then(({ data }) => {
        if (thenFn) thenFn(this, data.result, quickViewItem)
        else this.quickView = data.result
      })
      .finally(() => this.$emit('set-loader', false))
  }
}

export function getTaskData(taskName) {
  if (isSubShow()) return apiTo.GET_TASK_DATA_FOR_SUB_PERIOD(taskName, this.periodId)
  return apiTo.GET_TASK_DATA(taskName)
}
